import { cloneDeepWith } from 'lodash';

import { Query } from '../models/analytics-api/query.model';

export function cloneDeepPreservingQueries<T>(value: T): T {
  return cloneDeepWith(value, nested => (nested instanceof Query ? nested.clone() : undefined));
}
